<div data-testid="return-audit-page" class="p-4 flex-table-page">
  <app-search-form
    data-testid="return-audit-search-form"
    [searchFormat]="searchFormat"
    (formSearch)="onSearch()"
    (formReset)="onReset()"
  ></app-search-form>

  <app-status-filter
    data-testid="return-audit-status-filter"
    [statusOptions]="statusOptions"
    [primaryButton]="primaryButton"
    [secondaryButton]="secondaryButton"
    (primaryButtonClick)="onApprove()"
    (secondaryButtonClick)="onReject()"
  ></app-status-filter>

  <div class="flex-table-section">
    <app-data-table
      data-testid="return-audit-table"
      [dataSource]="pagedData()"
      [columns]="tableColumns"
      [rows]="pageSize()"
      [first]="first()"
      [totalRecords]="totalRecords()"
      scrollHeight="flex"
      [loading]="loading()"
      [selection]="selected()"
      [hasCheckColumn]="true"
      (selectionChange)="onSelectionChange($event)"
      (pageChange)="onPageChange($event)"
    ></app-data-table>
  </div>
</div>
